import { render, staticRenderFns, recyclableRender, components } from "./withdraw-select.vue?vue&type=template&id=6a7007e0&scoped=true&"
var renderjs
import script from "./withdraw-select.vue?vue&type=script&lang=js&"
export * from "./withdraw-select.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-select.vue?vue&type=style&index=0&lang=css&"
import style1 from "./withdraw-select.vue?vue&type=style&index=1&id=6a7007e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7007e0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/withdraw-select/withdraw-select.vue"
export default component.exports